/**
 * Created by giscafer on 2017/09/21.
 * based on pacakge viewer.js
 */
import {
  ContentChild,
  ContentChildren,
  Directive,
  ElementRef,
  Input,
  NgModule,
  OnDestroy,
  OnInit,
  Renderer2
} from "@angular/core";
import { CommonModule } from "@angular/common";

declare var Viewer: any;

@Directive({
  selector: '[viewer-content]',
})
export class ViewerContentDirective {

  nativeElement: HTMLElement;

  constructor(private _el: ElementRef) {
    this.nativeElement = this._el.nativeElement;
  }

}

@Directive({
  selector: '[viewer]'
})
export class ViewerDirective implements OnInit, OnDestroy {

  @Input()
  original: string = 'original';

  @ContentChild('content') content: ElementRef;

  @ContentChildren(ViewerContentDirective)
  set _imgContents(value: any) {
    this.imgContents = value;
    this.renderContent(true);
  }

  viewer: any;
  imgContents: any;
  nativeElement: HTMLElement;

  constructor(
    private _elementRef: ElementRef,
    private _render: Renderer2) {
    this.nativeElement = this._elementRef.nativeElement;
  }

  ngOnInit() {
    this.renderContent();
  }

  /**
   * If img dynamically increases, dynamic rendering
   * @param {boolean} flag Whether to dynamically increase rendering
   */
  renderContent(flag?: boolean) {
    let nativeEl = this.nativeElement;
    if (this.content) {
      nativeEl = this.content.nativeElement;
    }

    setTimeout(() => {
      let imgs = nativeEl.getElementsByTagName('img');

      if (imgs.length) {
        if (this.viewer) {
          this.viewer.destroy();
        }
        // if (!flag) {
        //   imgs[0].onload = () => {
        //     this.viewer = new Viewer(this.nativeElement, {
        //       url: this.original,
        //     });
        //   }
        // } else {
        //   imgs[imgs.length-1].onload = () => {
        //     this.viewer = new Viewer(this.nativeElement, {
        //       url: this.original,
        //     });
        //   }
        // }
        this.viewer = new Viewer(this.nativeElement, {
          url: this.original,
        });
      }
    }, 500);
  }

  ngOnDestroy(): void {
    if (this.viewer) {
      this.viewer.destroy();
    }
  }

}
/*
@NgModule({
  declarations: [
    ViewerDirective, ViewerContentDirective
  ],
  exports: [ViewerDirective, ViewerContentDirective],
  imports: [
    CommonModule
  ]
})
export class ViewerDirectiveModule {
}
*/


// WEBPACK FOOTER //
// ./src/directives/ng-viewer/viewer.directive.ts